// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './CurrentBoardHeaderUtil.scss';

const CurrentBoardHeaderUtil = ({ children, className, onClick }) => (
    <div className={classNames('CurrentBoardHeaderUtil', className)} onClick={onClick}>
        {children}
    </div>
);

CurrentBoardHeaderUtil.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default CurrentBoardHeaderUtil;
